import './App.css';
import { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Marketing/public pages — eager (LCP-critical, small)
import MarketingHome from './pages/MarketingHome';
import Login from './pages/Login';
import AdLanding from './pages/AdLanding';
import NotFound from './pages/NotFound';
const Book = lazy(() => import('./pages/Book'));
const Partners = lazy(() => import('./pages/Partners'));

// Admin OS / staff / portal — lazy (heavy, auth-only; kept out of the marketing bundle)
const OwnerLayout = lazy(() => import('./os/OwnerLayout'));
const Dashboard = lazy(() => import('./os/Dashboard'));
const Leads = lazy(() => import('./os/Leads'));
const Clients = lazy(() => import('./os/Clients'));
const Schedule = lazy(() => import('./os/Schedule'));
const Payments = lazy(() => import('./os/Payments'));
const Messages = lazy(() => import('./os/Messages'));
const StaffAdmin = lazy(() => import('./os/Staff'));
const Outreach = lazy(() => import('./os/Outreach'));
const Settings = lazy(() => import('./os/Settings'));
const ServicesAdmin = lazy(() => import('./os/Services'));
const Marketing = lazy(() => import('./os/Marketing'));
const Gallery = lazy(() => import('./os/Gallery'));
const MoneyMonth = lazy(() => import('./os/MoneyMonth'));
const MyDay = lazy(() => import('./staff/MyDay'));
const JobDetail = lazy(() => import('./staff/JobDetail'));
const Portal = lazy(() => import('./portal/Portal'));

function RedirectTo({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

const Fallback = () => (
  <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9d998f', fontFamily: 'Arial, sans-serif' }}>Loading…</div>
);

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<MarketingHome />} />
            <Route path="/index.html" element={<MarketingHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/book" element={<Book />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/lp/:variant" element={<AdLanding />} />
            <Route path="/bridgeman-downs" element={<RedirectTo to="/house-cleaning" />} />
            <Route path="/bridgeman-downs.html" element={<RedirectTo to="/house-cleaning" />} />

            <Route path="/owner" element={<ProtectedRoute roles={['admin']}><OwnerLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="clients" element={<Clients />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="payments" element={<Payments />} />
              <Route path="messages" element={<Messages />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="money" element={<MoneyMonth />} />
              <Route path="staff" element={<StaffAdmin />} />
              <Route path="outreach" element={<Outreach />} />
              <Route path="settings" element={<Settings />} />
              <Route path="services" element={<ServicesAdmin />} />
            </Route>

            <Route path="/staff" element={<ProtectedRoute roles={['cleaner', 'admin']}><MyDay /></ProtectedRoute>} />
            <Route path="/staff/job/:id" element={<ProtectedRoute roles={['cleaner', 'admin']}><JobDetail /></ProtectedRoute>} />

            <Route path="/portal" element={<ProtectedRoute roles={['client']}><Portal /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
